import React from "react";
import { useLocation } from "react-router-dom";
import { AuthProvider } from "oidc-react";
import lantbrukareAuthConfig from "@/config/auth-config";
import b2bAuthConfig from "@/config/b2b-auth-config";
import { isPublicRoute } from "@/constants";

interface RealmRouterProps {
  children: React.ReactNode;
}

/**
 * Route-based realm detection and AuthProvider wrapper.
 * Routes starting with /b2b use B2B realm, others use Lantbrukare realm.
 * Public routes (like /share/:token) skip OIDC authentication entirely.
 */
const RealmRouter: React.FC<RealmRouterProps> = ({ children }) => {
  const location = useLocation();

  // Skip OIDC authentication for public routes
  if (isPublicRoute(location.pathname)) {
    return <>{children}</>;
  }

  const isB2bRoute = location.pathname.startsWith("/b2b");
  const authConfig = isB2bRoute ? b2bAuthConfig : lantbrukareAuthConfig;

  return <AuthProvider {...authConfig}>{children}</AuthProvider>;
};

export default RealmRouter;
